import React from 'react';
import A18n from '../../../common/A18n';

export default function loadingMessage(_) {
  return <A18n rsx="marketplace.searchbars.common.artist.m5" />;
}
